import { IWorker } from 'types';

export const formatFIO = ({
  last_name,
  first_name,
}: Partial<IWorker>): string =>
  `${last_name} ${first_name && first_name[0] + '.'}`;
